
export function getPreviousWeekWithYear() {
    const today = new Date();
  
    // Set the target to the nearest Thursday for consistency
    const dayOfWeek = today.getUTCDay(); // 0 is Sunday, 6 is Saturday
    const nearestThursday = new Date(today.getTime());
    nearestThursday.setUTCDate(today.getUTCDate() + (3 - (dayOfWeek + 6) % 7));
  
    // Subtract 7 days to get the previous week
    nearestThursday.setUTCDate(nearestThursday.getUTCDate() - 7);
  
    // Get the year and the start of the year (January 1st)
    const year = nearestThursday.getUTCFullYear();
    const startOfYear = new Date(Date.UTC(year, 0, 1));
  
    // Calculate the week number
    const weekNumber = Math.ceil((((nearestThursday - startOfYear) / 86400000) + startOfYear.getUTCDay() + 1) / 7);
  
    return `${year}-W${weekNumber.toString().padStart(2, '0')}`;
  }
  

  export function getPreviousWeekFromWeekString(weekStr) {
    if (!weekStr) return null;

    const [yearStr, weekPart] = weekStr.split('-W');
    const year = parseInt(yearStr, 10);
    const week = parseInt(weekPart, 10);

    // Create a date for the first day of the given week
    const jan4 = new Date(Date.UTC(year, 0, 4)); // January 4th is always in week 1
    const dayOffset = (week - 1) * 7;
    const date = new Date(jan4.getTime() + dayOffset * 86400000);

    // Adjust to the start of the week (Monday)
    const day = date.getUTCDay();
    const diffToMonday = (day + 6) % 7;
    date.setUTCDate(date.getUTCDate() - diffToMonday);

    // Subtract 7 days to get previous week
    date.setUTCDate(date.getUTCDate() - 7);

    // Get ISO year and week
    const newYear = date.getUTCFullYear();
    const newJan4 = new Date(Date.UTC(newYear, 0, 4));
    const weekNumber = Math.ceil((((date - newJan4) / 86400000) + newJan4.getUTCDay() + 1) / 7);

    return `${newYear}-W${weekNumber.toString().padStart(2, '0')}`;
}
